import React from "react";
import type { FC, JSX, PropsWithChildren } from "react";

import ButtonsView from "../../../Button/ButtonsView/ButtonsView";
import { createDisplayNameForUniCardElement } from "../../utils/getDisplayName";
import { createTestIdForUniCardElement } from "../../utils/getTestId";

import type { ButtonsViewProps } from "../../../Button";

import classes from "./UniCardButtonsView.styl";

const UNI_CARD_BUTTONS_VIEW_TEST_ID =
    createTestIdForUniCardElement("buttons-view");

export const UniCardButtonsView: FC<PropsWithChildren<ButtonsViewProps>> = ({
    children,
    ...props
}): JSX.Element => {
    return (
        <div className={classes["buttons-view"]}>
            <ButtonsView {...props} data-tsid={UNI_CARD_BUTTONS_VIEW_TEST_ID}>
                {children}
            </ButtonsView>
        </div>
    );
};

UniCardButtonsView.displayName =
    createDisplayNameForUniCardElement("ButtonsView");

export default UniCardButtonsView;
